export { coreDetailsTab } from "./CoreDetails";

export { documentsTab } from "./Documents";

export { caseConversationTab } from "@teamprevent/common/messaging/components/CaseConversationTab";

export { FinanceInformationTab } from "../../../ohCaseFinanceInformation/components/FinanceInformationTab";
